import { render, staticRenderFns } from "./icon-arrow.vue?vue&type=template&id=5ee24e9f&scoped=true"
import script from "./icon-arrow.vue?vue&type=script&lang=js"
export * from "./icon-arrow.vue?vue&type=script&lang=js"
import style0 from "./icon-arrow.vue?vue&type=style&index=0&id=5ee24e9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee24e9f",
  null
  
)

export default component.exports